module.exports = __webpack_public_path__ + "img/10.a3a23b99.png";